import React from 'react'
import clsx from 'clsx'
import { Box, Grid, Typography } from '@material-ui/core'
import { useHomeStore } from '../../../context/HomeStore'
import { GRAY_COLORS } from '../../../asterX-UI'
import { useDocumentStyles } from '../document.styles'



const SignerCards = ({ signers, currentSignerIndex, hoveredSignerIndex, setHoveredSignerIndex }) => {
  const classes = useDocumentStyles()
  const {
    homeStore: { document }
  } = useHomeStore()

  return (
    <>
      {signers.map((signer, index) => {
        const isSigned = index < currentSignerIndex
        const isCurrent = index === currentSignerIndex
        const isRefused= document?.currentStatus==="REFUSED" && isCurrent

        const outlineColor =
          isSigned ? '1px solid green' :
            isCurrent ? `2px solid ${document?.currentStatus === 'ACCESSED' ? GRAY_COLORS[500] :
                document?.currentStatus === 'REFUSED'? 'red': 'black'}` :
              `1px solid ${GRAY_COLORS[300]}`

        return (
          <Box
            key={index}
            className={clsx(classes.card, { [classes.cardHovered]: hoveredSignerIndex === index })}
            style={{ border: outlineColor, marginBottom: '1rem' }}
            onMouseEnter={() => setHoveredSignerIndex && setHoveredSignerIndex(index)}
            onMouseLeave={() => setHoveredSignerIndex && setHoveredSignerIndex(null)}
          >
            <Box className={classes.cardContent}>
              <Typography className={classes.cardTitle}>
                {signer.signerType === 'COMPANY' ? `Компания: ${signer.fullName}` :
                  signer.signerType==='GUARANTEE' ? `Гарант: ${signer.fullName}` : `Подписант: ${signer.fullName}`}
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography className={classes.description}>
                    {signer.signerType === 'COMPANY' ? 'БИН' : 'ИИН'}: {signer.identifier || '-'}
                  </Typography>
                </Grid>
                {signer.phoneNumber && (
                  <Grid item xs={12}>
                    <Typography className={classes.description}>
                      Телефон: {signer.phoneNumber}
                    </Typography>
                  </Grid>
                )}
              </Grid>
              {isSigned && (
                <Typography style={{ color: 'green', marginTop: 10 }}>
                  Подписано
                </Typography>
              )}
              {isRefused &&(
                <Typography style={{ color: 'red', marginTop: 10 }}>
                  Отказано
                </Typography>
              )}
            </Box>
          </Box>
        )
      })}
    </>
  )
}
export default SignerCards
